import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { namespace } from '@/modules/car/namespace';

import { setCars } from '../actions';

const loadCars = createAsyncThunk(
  `${namespace}/load-cars`,
  async ({ limit, offset }: { limit: number; offset: number }, { dispatch }) => {
    const cars = await carAPI.fetchCars({ limit, offset });

    dispatch(setCars(cars));

    return cars;
  },
);

export { loadCars };
